var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import { MAX_POWER_VALUE, MIN_POWER_VALUE, POWER_GAP } from '../../utils/card-powers';
import Accordion from '../common/accordion';
import DoubleSlider from '../common/double-slider';
export default function PowerForm(_a) {
    var minValue = _a.minValue, maxValue = _a.maxValue, setMinValue = _a.setMinValue, setMaxValue = _a.setMaxValue;
    var t = useI18n().t;
    return (_jsx(Accordion, { defaultValue: true, height: 80, title: t('filters.power'), children: _jsx(Container, { children: _jsx(DoubleSlider, { gap: POWER_GAP, maxThreshold: MAX_POWER_VALUE, maxValue: maxValue, minThreshold: MIN_POWER_VALUE, minValue: minValue, setMaxValue: setMaxValue, setMinValue: setMinValue }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding: 0 24px;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding: 0 24px;\n  width: 100%;\n"])));
var templateObject_1;
